<div
  class="tw-flex tw-h-96 tw-flex-col tw-items-center tw-justify-center tw-bg-[url(src/assets/img/banner/cosif-banner.png)] tw-bg-cover tw-bg-center tw-bg-no-repeat"
>
  <div
    class="tw-flex tw-w-full tw-max-w-[1280px] tw-flex-col tw-items-center tw-gap-10 tw-px-16 tw-py-10"
  >
    <div
      class="tw-flex tw-w-80 tw-justify-center tw-gap-10 tw-rounded-md tw-bg-white tw-bg-opacity-50 tw-p-4 lg:tw-w-[28rem]"
    >
      <img src="/assets/img/logo/sc-logo.svg" alt="UM Innovations" class="tw-h-24 lg:tw-h-32" />
      <img src="/assets/img/logo/miti-logo.svg" alt="UM Innovations" class="tw-h-24 lg:tw-h-32" />
    </div>
    <h1
      class="tw-m-0 tw-flex tw-flex-col tw-text-center tw-text-3xl tw-font-semibold tw-tracking-wide tw-text-white lg:tw-text-4xl lg:tw-leading-[3rem]"
    >
      NIMP 2030 Strategic Co-Investment Fund (CoSIF)
    </h1>
  </div>
</div>
<div class="tw-relative tw-flex tw-w-screen tw-justify-center tw-bg-[#0f253b]">
  <div
    class="tw-absolute tw-left-0 tw-z-0 tw-hidden tw-h-full tw-w-6/12 tw-bg-white lg:tw-flex"
  ></div>
  <div
    class="tw-z-10 tw-flex tw-w-full tw-max-w-[1280px] tw-flex-col lg:tw-flex-row lg:tw-justify-center"
  >
    <section
      class="tw-w-full tw-bg-white tw-p-1 lg:tw-flex lg:tw-flex-1 lg:tw-justify-end lg:tw-py-4"
    >
      <div class="tw-flex tw-flex-col tw-items-center tw-p-8 lg:tw-pl-[15px]">
        <div class="tw-max-w-[35rem] tw-text-black md:tw-max-w-[80rem] lg:tw-pl-0">
          <p
            class="tw-text-left tw-text-base tw-font-semibold tw-leading-normal tw-tracking-wide sm:tw-text-sm md:tw-text-lg"
          >
            Unlock up to RM20 Million Co-Investment from CoSIF! 
          </p>
          <p
            class="tw-text-left tw-text-base tw-font-normal tw-leading-normal sm:tw-text-sm md:tw-text-lg"
          >
            CoSIF is a joint initiative by MITI and the SC to encourage private investments into key
            manufacturing sectors identified in the National Industry Masterplan (NIMP). If you are
            in manufacturing and seeking capital, this might be the right scheme for you. Reach out
            to us to learn more.
          </p>
        </div>
      </div>
    </section>
    <section
      class="tw-flex tw-flex-col tw-items-center tw-bg-[#0f253b] tw-p-6 tw-text-white lg:tw-max-w-[20rem] lg:tw-items-start lg:tw-justify-start lg:tw-py-12 lg:tw-pl-14"
    >
      <p
        class="tw-mb-1 tw-text-center tw-text-base md:tw-text-lg lg:tw-text-left lg:tw-text-lg lg:tw-font-thin"
      >
        Not sure whether you qualify?
      </p>
      <p class="tw-text-xl tw-font-semibold tw-tracking-wide lg:tw-text-lg">
        Interested to know more?
      </p>
      <p class="tw-text-xl tw-font-semibold tw-tracking-wide lg:tw-text-lg">Discover how.</p>
      <a
        class="tw-flex tw-w-fit tw-cursor-pointer tw-justify-center tw-rounded-full tw-bg-[#50bfbf] tw-p-4 tw-text-lg tw-font-semibold tw-text-white tw-shadow hover:tw-text-white lg:tw-mt-4 lg:tw-px-4 lg:tw-py-2"
        href="https://forms.clickup.com/9008241541/p/f/8cexpw5-53436/I11MV7VK3OCWG162DV/cosif?Source=NIMP%20Interest%20Form"
        target="_blank"
      >
        Book a session with us
      </a>
    </section>
  </div>
</div>

<div
  style="
    position: relative;
    width: 100%;
    height: 0;
    padding-top: 163.6896%;
    padding-bottom: 0;
    box-shadow: 0 2px 8px 0 rgba(63, 69, 81, 0.16);
    overflow: hidden;
    border-radius: 8px;
    will-change: transform;
  "
>
  <iframe
    loading="lazy"
    style="
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      border: none;
      padding: 0;
      margin: 0;
    "
    src="https://www.canva.com/design/DAGmvPX9pdI/tstSjouk8LPML71NJGhLiA/view?embed"
    allowfullscreen="allowfullscreen"
    allow="fullscreen"
  >
  </iframe>
</div>
